// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two-factor-authentication-reminder .el-dialog__body{position:relative}.two-factor-authentication-reminder .el-dialog__body .two-factor-authentication-reminder-close{position:absolute;top:16px;right:16px}@media(max-width: 500px){.two-factor-authentication-reminder{width:calc(100% - 32px) !important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
